import styled from 'styled-components'
import { get } from '../../utils/theme'

export const H5 = styled.h5`
  ${get('styles.h5')};
`
